module.exports = __webpack_public_path__ + "img/multimedia-collage-mobile.bca64c30.png";